/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-nested-ternary */
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'
import 'swiper/css/autoplay'

import React, { useCallback, useMemo } from 'react'
import {
  A11y,
  Autoplay,
  Controller,
  EffectFade,
  Navigation,
  Pagination,
} from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import { carouselStyling } from './CarouselComponent.module.css'

const Carousel = React.memo(
  ({
    breakpoints,
    children,
    extraClassName,
    fullWidth,
    isDesktop,
    nextBtn,
    pagination,
    prevBtn,
    showCustomNav,
    slidesPerView,
    spaceBetween,
    withoutNav,
  }) => {
    const modules = useMemo(
      () =>
        withoutNav
          ? [A11y, Pagination, Autoplay, Controller, EffectFade]
          : [Navigation, A11y, Pagination],
      [withoutNav],
    )

    const navigation = useMemo(
      () =>
        nextBtn && prevBtn && showCustomNav
          ? { nextEl: nextBtn, prevEl: prevBtn }
          : {},
      [nextBtn, prevBtn, showCustomNav],
    )

    const renderSlides = useCallback(
      () =>
        children &&
        children.map((slide, index) => (
          <SwiperSlide key={index}>{slide}</SwiperSlide>
        )),
      [children],
    )

    return (
      <div className={`${carouselStyling} ${extraClassName}`}>
        <Swiper
          autoplay={{ delay: 3000, waitForTransition: true }}
          breakpoints={breakpoints}
          loop={false}
          modules={modules}
          navigation={withoutNav ? false : navigation}
          pagination={pagination}
          slidesPerView={fullWidth ? 1 : slidesPerView || (isDesktop ? 4 : 1)}
          spaceBetween={spaceBetween}
          speed={1000}
        >
          {renderSlides()}
        </Swiper>
      </div>
    )
  },
)

export default Carousel
